import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { ServiceLv1ServiceOperationalCard } from './ServiceLv1ServiceOperationalCard';
import { ServiceLv1ServiceTechnicalCard } from './ServiceLv1ServiceTechnicalCard';

/**
 * ServiceLv1 Page Component
 */
const ServiceLv1 = () => {

  const screenId = 'MyM303';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [serviceContents, setServiceContents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const callbackRequestServiceContents = (result) => {
      setServiceContents(result)
      setIsLoading(false);
    }
    apiRequest.requestJson('api/service/lv1', 'GET', callbackRequestServiceContents)
  }, []);

  if (isLoading)
    return <MyMProgress />

  const navigateServiceLv2 = (metadataId) => {
    navigate(`MyM304/${metadataId}`);
  }

  const StyledGrid = styled(Grid)(() => ({
    '> .MuiGrid-item': {
      '> .MuiCard-root': {
        border: '2px solid #D4D4D4',
      },
    },
    '@media (min-width: 960px)': {
      height: '100%',
    },
    width: '100%'
  }));

  const childCardDefaultProps = {
    navigateServiceLv2: navigateServiceLv2,
    controlSettings: controlSettings,
    screenId: screenId,
  };

  return (
    <Box className='py-1'>
      <Box className='mb-2'>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblServiceLv1Title}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblServiceMassage}</MyMLabel>
      </Box>

      {/* 2024.9.16 MyMine Version2.0対応 Modify Start */}
      <Grid container>
        <Grid item md={12} lg={6} className='w-100'>
          <MyMVariantLabel className='py-1 text-break' sx={{ margin: "0% 3% 0%" }} variant='h5'>{serviceContents.TechnicalDocumentGroup.GroupMetadataName}</MyMVariantLabel>
          <StyledGrid container className='pb-2'>
            <Grid item xs={11} className='py-0' sx={{ marginLeft: 'auto', marginRight: 'auto' }}>
              <ServiceLv1ServiceTechnicalCard
                {...childCardDefaultProps}
                technicalDocumentGroup={serviceContents.TechnicalDocumentGroup}
                productTypeList={serviceContents.ProductTypeList}
              />
            </Grid>
          </StyledGrid>
        </Grid>
        <Grid item md={12} lg={6}>
          <MyMVariantLabel className='py-1 text-break' sx={{ margin: "0% 3% 0%" }} variant='h5'>{controlSettings.LabelList.lblOperationalProcessTitle}</MyMVariantLabel>
          <StyledGrid container className='pb-2'>
            <Grid item xs={11} className='py-0' sx={{ marginLeft: 'auto', marginRight: 'auto' }}>
              <ServiceLv1ServiceOperationalCard
                {...childCardDefaultProps}
              />
            </Grid>
          </StyledGrid>
        </Grid>

      </Grid>
      {/* 2024.9.16 MyMine Version2.0対応 Modify End */}
    </Box>
  );
}
export default ServiceLv1;
